import { get_translations } from "@pdfking/workflow/utils/make_translations"

import prompt from "./prompt"

/**
 * Shows a confirmation dialog with Continue/Abort buttons
 * @param message The message to display in the dialog
 * @returns Promise that resolves to true if confirmed, false if aborted or closed
 */
export default (message?: string): Promise<boolean> =>
  get_translations("actions")
    .then(actions =>
      prompt({
        buttons: {
          abort: actions.ABORT,
          continue: actions.CONTINUE,
        },
        default_button: "continue",
        title: message || actions.ARE_YOU_SURE,
      })
    )
    .then(({ result }) => result === "continue")
